[
  {
    "data_types": [
      "Account information",
      "User content",
      "Messages",
      "AI interactions",
      "Clipboard content",
      "Purchase information",
      "Phone and social network contacts",
      "Account settings and communication preferences",
      "Information to verify an account",
      "Information in correspondence",
      "Information from advertisers\u2019 forms",
      "Information from surveys, research, promotions, marketing campaigns, events, or contests"
    ],
    "category": "Information You Provide",
    "purposes": [
      {
        "reason": "Create and manage account",
        "evidence": [12, 64],
        "certainty": "high"
      },
      {
        "reason": "Provide services, products, features",
        "evidence": [64, 66, 67, 68, 69, 71],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [65, 66],
        "certainty": "high"
      },
      {
        "reason": "Process transactions or payments",
        "evidence": [19, 67],
        "certainty": "high"
      },
      {
        "reason": "Provide customer support",
        "evidence": [64, 75],
        "certainty": "high"
      },
      {
        "reason": "Security and identification",
        "evidence": [73, 74, 76],
        "certainty": "high"
      },
      {
        "reason": "Targeted and personalized advertisements",
        "evidence": [70],
        "certainty": "high"
      },
      {
        "reason": "Comply with legal requirements and authorities",
        "evidence": [77],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [138, 141],
        "certainty": "high"
      },
      {
        "duration": "Longer for legal reasons and/or obligations",
        "evidence": [139],
        "certainty": "high"
      },
      {
        "duration": "Longer in case of violations",
        "evidence": [142],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [84, 85, 86, 87, 88, 89, 90, 91, 92, 93],
        "certainty": "high"
      },
      {
        "party": "Partners and Affiliates",
        "evidence": [100],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [102, 103],
        "certainty": "high"
      },
      {
        "party": "General public",
        "evidence": [104, 105],
        "certainty": "high"
      },
      {
        "party": "Others",
        "evidence": [109, 110],
        "certainty": "high"
      }
    ],
    "sensitive": "partially sensitive"
  },
  {
    "data_types": [
      "Usage information",
      "Technical information",
      "Location information",
      "Content characteristics and features",
      "Biometric identifiers and biometric information",
      "Metadata",
      "Cookies and other similar technologies"
    ],
    "category": "Automatically Collected Information",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [64, 66, 67, 68, 69, 71],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [65, 66],
        "certainty": "high"
      },
      {
        "reason": "Measurement and analytics",
        "evidence": [51, 52, 53, 54, 65],
        "certainty": "high"
      },
      {
        "reason": "Security and identification",
        "evidence": [73, 74, 76],
        "certainty": "high"
      },
      {
        "reason": "Targeted and personalized advertisements",
        "evidence": [70],
        "certainty": "high"
      },
      {
        "reason": "Comply with legal requirements and authorities",
        "evidence": [77],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [138, 141],
        "certainty": "high"
      },
      {
        "duration": "Longer for legal reasons and/or obligations",
        "evidence": [139],
        "certainty": "high"
      },
      {
        "duration": "Longer in case of violations",
        "evidence": [142],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [84, 85, 86, 87, 88, 89, 90, 91, 92, 93],
        "certainty": "high"
      },
      {
        "party": "Partners and Affiliates",
        "evidence": [100],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [102, 103],
        "certainty": "high"
      },
      {
        "party": "General public",
        "evidence": [104, 105],
        "certainty": "high"
      },
      {
        "party": "Others",
        "evidence": [109, 110],
        "certainty": "high"
      }
    ],
    "sensitive": "partially sensitive"
  },
  {
    "data_types": [
      "Information from third-party services",
      "Information from advertisers, publishers, and measurement partners",
      "Information from sellers",
      "Information from payment and transaction fulfillment providers",
      "Information from affiliates",
      "Information from others",
      "Information from professional organizations, businesses, government authorities, and publicly-available sources"
    ],
    "category": "Information From Other Sources",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [64, 66, 67, 68, 69, 71],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [65, 66],
        "certainty": "high"
      },
      {
        "reason": "Measurement and analytics",
        "evidence": [51, 52, 53, 54, 65],
        "certainty": "high"
      },
      {
        "reason": "Security and identification",
        "evidence": [73, 74, 76],
        "certainty": "high"
      },
      {
        "reason": "Targeted and personalized advertisements",
        "evidence": [70],
        "certainty": "high"
      },
      {
        "reason": "Comply with legal requirements and authorities",
        "evidence": [77],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [138, 141],
        "certainty": "high"
      },
      {
        "duration": "Longer for legal reasons and/or obligations",
        "evidence": [139],
        "certainty": "high"
      },
      {
        "duration": "Longer in case of violations",
        "evidence": [142],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [84, 85, 86, 87, 88, 89, 90, 91, 92, 93],
        "certainty": "high"
      },
      {
        "party": "Partners and Affiliates",
        "evidence": [100],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [102, 103],
        "certainty": "high"
      },
      {
        "party": "General public",
        "evidence": [104, 105],
        "certainty": "high"
      },
      {
        "party": "Others",
        "evidence": [109, 110],
        "certainty": "high"
      }
    ],
    "sensitive": "partially sensitive"
  }
]
